<template>
  <div class="culture-page">
    <Hero 
      title="Culture" 
      subtitle="Discover the rich traditions and timeless wisdom of Chinese culture"
      :imageUrl="heroImage" 
      height="50vh"
    />
    <section class="articles-section section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">Cultural Insights</h2>
          <p class="section-description">
            Explore traditional festivals, ancient practices, and the living heritage that continues to shape modern China.
          </p>
        </div>
        <div class="articles-grid">
          <ArticleCard
            v-for="article in articles"
            :key="article.id"
            :article="article"
            :section="'culture'"
          />
        </div>
        <div v-if="articles.length === 0" class="no-articles">
          <div class="no-articles-content">
            <svg class="no-articles-icon" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h3>No articles yet</h3>
            <p>Check back soon for new cultural insights and stories.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Import the image
import heroImage from '@/assets/images/culture-hero.jpg';

import Hero from '@/components/Hero.vue';
import ArticleCard from '@/components/ArticleCard.vue';
import articles from '@/content/culture/articles.js';

export default {
  name: 'Culture',
  components: {
    Hero,
    ArticleCard,
  },
  data() {
    return {
      articles,
      heroImage, // Use the imported image
    };
  },
};
</script>

<style scoped>
.section-header {
  text-align: center;
  margin-bottom: var(--space-12);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-family: var(--font-display);
  font-size: var(--text-4xl);
  font-weight: 600;
  color: var(--neutral-900);
  margin-bottom: var(--space-4);
  line-height: var(--leading-tight);
}

.section-description {
  font-size: var(--text-lg);
  color: var(--neutral-600);
  line-height: var(--leading-relaxed);
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: var(--space-8);
  margin-bottom: var(--space-12);
}

.no-articles {
  text-align: center;
  padding: var(--space-20) var(--space-4);
}

.no-articles-content {
  max-width: 400px;
  margin: 0 auto;
}

.no-articles-icon {
  width: 64px;
  height: 64px;
  color: var(--neutral-400);
  margin-bottom: var(--space-6);
}

.no-articles h3 {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  color: var(--neutral-700);
  margin-bottom: var(--space-3);
}

.no-articles p {
  color: var(--neutral-500);
  font-size: var(--text-base);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .articles-grid {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: var(--space-6);
  }
}

@media (max-width: 768px) {
  .articles-grid {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
  
  .section-title {
    font-size: var(--text-3xl);
  }
  
  .section-description {
    font-size: var(--text-base);
  }
  
  .no-articles {
    padding: var(--space-16) var(--space-4);
  }
}

@media (max-width: 480px) {
  .section-header {
    margin-bottom: var(--space-8);
  }
  
  .section-title {
    font-size: var(--text-2xl);
  }
  
  .section-description {
    font-size: var(--text-sm);
  }
  
  .articles-grid {
    gap: var(--space-4);
  }
}
</style>